import React, { useEffect, useRef, useState } from 'react';
import {
  FaWhatsapp,
  FaEnvelope,
  FaPhone,
  FaCheck,
  FaCogs,
  FaCubes,
  FaDraftingCompass,
  FaIndustry,
  FaTools,
  FaArrowRight,
  FaStar,
  FaCalendarAlt,
  FaChevronDown,
  FaChevronLeft,
  FaChevronRight
} from 'react-icons/fa';

// Fotos dos depoimentos
import dep1Photo from '../../assets/dep1.svg';
import dep2Photo from '../../assets/dep2.svg';
import dep3Photo from '../../assets/dep3.svg';
import dep4Photo from '../../assets/dep4.svg';

// Modal de formulário HubSpot
import ContactFormModal from './components/ContactFormModal';

// Banner de Cookies (LGPD)
import CookieConsent from './components/CookieConsent';

import {
  PageWrapper,
  GridBackground,
  HeroSection,
  HeroContent,
  HeroBadge,
  HeroTitle,
  HeroSubtitle,
  HeroCTA,
  HeroButton,
  HeroButtonSecondary,
  HeroImageStack,
  HeroImageCard,
  HeroImageWrapper,
  HeroImageTooltip,
  // Depoimentos
  TestimonialsSection,
  TestimonialsHeader,
  TestimonialsTitle,
  TestimonialsWrapper,
  TestimonialsTrack,
  TestimonialsCarousel,
  CarouselControls,
  CarouselDot,
  CarouselButton,
  TestimonialCard,
  TestimonialHeader,
  TestimonialText,
  TestimonialTextWrapper,
  ReadMoreButton,
  TestimonialStars,
  TestimonialMeta,
  TimeAgo,
  AuthorPhoto,
  AuthorAvatar,
  AuthorInfo,
  AuthorName,
  // Serviços
  ServicesSection,
  SectionHeader,
  SectionTitle,
  SectionSubtitle,
  ServicesGrid,
  ServiceCard,
  ServiceIcon,
  ServiceTitle,
  ServiceList,
  // CTA
  CTASection,
  CTAContent,
  CTATitle,
  CTASubtitle,
  CTAButtons,
  PrimaryButton,
  SecondaryButton,
  ContactRow,
  // WhatsApp Flutuante
  WhatsAppFloat
} from './styles';

import heroImage1 from '../../assets/hero-cadpro.svg';
import heroImage2 from '../../assets/hero-cadpro2.svg';
import heroImage3 from '../../assets/hero-cadpro3.svg';
import heroImage4 from '../../assets/hero-cadpro4.svg';
import heroImage5 from '../../assets/hero-cadpro5.svg';
import heroImage6 from '../../assets/hero-cadpro6.svg';
import heroImage7 from '../../assets/hero-cadpro7.svg';
import heroImage8 from '../../assets/hero-cadpro8.svg';
import heroImage9 from '../../assets/hero-cadpro9.svg';
import heroImage10 from '../../assets/hero-cadpro10.svg';
import heroImage11 from '../../assets/hero-cadpro11.svg';
import heroImage12 from '../../assets/hero-cadpro12.svg';
import heroImage13 from '../../assets/hero-cadpro13.svg';
import heroImage14 from '../../assets/hero-cadpro14.svg';
import heroImage15 from '../../assets/hero-cadpro15.svg';
import heroImage16 from '../../assets/hero-cadpro16.svg';
import heroImage17 from '../../assets/hero-cadpro17.svg';
import heroImage18 from '../../assets/hero-cadpro18.svg';

// GIF animado do hero (com transparência)
import heroVideo1 from '../../assets/hero-video1.gif';

// Componente de Card de Depoimento com expansão
const TestimonialCardComponent = ({ testimonial, index, onPause }) => {
  const [expanded, setExpanded] = useState(false);
  const needsExpansion = testimonial.text.length > 150; // Textos > 150 chars mostram "Ler mais"

  const handleReadMore = () => {
    setExpanded(!expanded);
    if (!expanded && onPause) {
      onPause(); // Pausa o carrossel ao expandir
    }
  };

  return (
    <TestimonialCard 
      className="animate-on-scroll"
      style={{ animationDelay: `${index * 0.1}s` }}
    >
      <TestimonialHeader>
        {testimonial.photo ? (
          <AuthorPhoto src={testimonial.photo} alt={testimonial.author} />
        ) : (
          <AuthorAvatar>{testimonial.initials}</AuthorAvatar>
        )}
        <AuthorInfo>
          <AuthorName>{testimonial.author}</AuthorName>
          <TestimonialMeta>
            <TestimonialStars>
              {[...Array(testimonial.stars)].map((_, i) => (
                <FaStar key={i} />
              ))}
            </TestimonialStars>
            {testimonial.timeAgo && <TimeAgo>{testimonial.timeAgo}</TimeAgo>}
          </TestimonialMeta>
        </AuthorInfo>
      </TestimonialHeader>
      
      <TestimonialTextWrapper $expanded={expanded || !needsExpansion}>
        <TestimonialText>
          {testimonial.text}
        </TestimonialText>
      </TestimonialTextWrapper>
      
      {needsExpansion && (
        <ReadMoreButton 
          onClick={handleReadMore}
          $expanded={expanded}
        >
          {expanded ? 'Ler menos' : 'Ler mais'} <FaChevronDown />
        </ReadMoreButton>
      )}
    </TestimonialCard>
  );
};

const EngenhariaAplicada = () => {
  const observerRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false); // Estado do modal
  const [testimonialIndex, setTestimonialIndex] = useState(0); // Estado do carrossel
  const [carouselPaused, setCarouselPaused] = useState(false); // Pausar carrossel
  const [isMobile, setIsMobile] = useState(false); // Detectar mobile
  
  // Número máximo de posições do carrossel
  // Desktop: 4 depoimentos - 3 visíveis = 2 posições (0 e 1)
  // Mobile: 4 depoimentos - 1 visível = 4 posições (0, 1, 2, 3)
  const maxTestimonialIndex = isMobile ? 3 : 1;

  // Detectar se é mobile
  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      // Resetar índice ao mudar de mobile para desktop
      setTestimonialIndex(0);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Função para pausar carrossel por 1 minuto
  const pauseCarousel = () => {
    setCarouselPaused(true);
    setTimeout(() => {
      setCarouselPaused(false);
    }, 60000); // 1 minuto = 60000ms
  };
  
  // Array de imagens do hero com legendas descritivas
  const heroImages = [
    { src: heroImage13, alt: 'Projeto de Ferramenta Progressiva', label: 'Ferramenta Progressiva', type: 'image' },
    { src: heroImage2, alt: 'Projeto de Ferramenta Progressiva', label: 'Ferramenta Progressiva', type: 'image' },
    { src: heroImage5, alt: 'Projeto de Ferramenta Progressiva', label: 'Ferramenta Progressiva', type: 'image' },
    { src: heroImage1, alt: 'Projeto de Ferramenta Tandem', label: 'Ferramenta Tandem', type: 'image' },
    // { src: heroVideo1, alt: 'Simulação de Estampagem', label: 'Simulação de Estampagem', type: 'video' },
    { src: heroImage6, alt: 'Projeto de Ferramenta Tandem 1/4', label: 'Ferramenta Tandem - Op. 1/4', type: 'image' },
    { src: heroImage7, alt: 'Projeto de Ferramenta Tandem 2/4', label: 'Ferramenta Tandem - Op. 2/4', type: 'image' },
    { src: heroImage8, alt: 'Projeto de Ferramenta Tandem 3/4', label: 'Ferramenta Tandem - Op. 3/4', type: 'image' },
    { src: heroImage9, alt: 'Projeto de Ferramenta Tandem 4/4', label: 'Ferramenta Tandem - Op. 4/4', type: 'image' },
    { src: heroImage10, alt: 'Dispositivo de Controle', label: 'Dispositivo de Controle', type: 'image' },
    { src: heroImage14, alt: 'Projeto de Ferramenta Tandem 1/5', label: 'Ferramenta Tandem - Op. 1/5', type: 'image' },
    { src: heroImage15, alt: 'Projeto de Ferramenta Tandem 2/5', label: 'Ferramenta Tandem - Op. 2/5', type: 'image' },
    { src: heroImage16, alt: 'Projeto de Ferramenta Tandem 3/5', label: 'Ferramenta Tandem - Op. 3/5', type: 'image' },
    { src: heroImage17, alt: 'Projeto de Ferramenta Tandem 4/5', label: 'Ferramenta Tandem - Op. 4/5', type: 'image' },
    { src: heroImage18, alt: 'Projeto de Ferramenta Tandem 5/5', label: 'Ferramenta Tandem - Op. 5/5', type: 'image' },
    { src: heroImage11, alt: 'Dispositivo de Solda MIG Robô', label: 'Dispositivo de Solda MIG Robô', type: 'image' },
    { src: heroImage12, alt: 'Dispositivo de Solda MIG Robô', label: 'Dispositivo de Solda MIG Robô', type: 'image' },
    { src: heroImage3, alt: 'Projeto de Dispositivo de Solda Projeção', label: 'Dispositivo Solda Projeção', type: 'image' },
  ];

  // Rotação automática das imagens - pausa mais tempo no vídeo
  useEffect(() => {
    const currentItem = heroImages[activeIndex];
    const isVideo = currentItem?.type === 'video';
    
    // Se for vídeo, espera 20 segundos (duração do vídeo)
    // Se for imagem, espera 5 segundos
    const duration = isVideo ? 20000 : 5000;
    
    const timeout = setTimeout(() => {
      setActiveIndex((prev) => (prev + 1) % heroImages.length);
    }, duration);
    
    return () => clearTimeout(timeout);
  }, [activeIndex, heroImages.length]);

  // Rotação automática do carrossel de depoimentos a cada 6 segundos
  useEffect(() => {
    if (carouselPaused) return; // Não rotaciona se estiver pausado
    
    const interval = setInterval(() => {
      setTestimonialIndex((prev) => (prev >= maxTestimonialIndex ? 0 : prev + 1));
    }, 6000);
    return () => clearInterval(interval);
  }, [maxTestimonialIndex, carouselPaused]);

  // Escuta evento do Header para abrir o modal
  useEffect(() => {
    const handleOpenModal = () => setIsModalOpen(true);
    window.addEventListener('openContactModal', handleOpenModal);
    return () => window.removeEventListener('openContactModal', handleOpenModal);
  }, []);

  useEffect(() => {
    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { 
        threshold: 0.1,
        rootMargin: '50px'
      }
    );

    // Pequeno delay para garantir que o DOM está pronto
    setTimeout(() => {
      document.querySelectorAll('.animate-on-scroll').forEach((el) => {
        observerRef.current.observe(el);
      });
    }, 100);

    return () => observerRef.current?.disconnect();
  }, []);

  const services = [
    {
      icon: <FaDraftingCompass />,
      title: 'Análise e Planejamento',
      items: ['Análise Crítica', 'Simulação de Estampagem', 'Plano de Métodos (PLM)', 'Estudo de Tira', 'DFM / DFA']
    },
    {
      icon: <FaCogs />,
      title: 'Ferramentas de Estampagem',
      items: ['Progressivas', 'Transfer', 'Tandem (Robotizada / Manual)', 'PFMEA']
    },
    {
      icon: <FaTools />,
      title: 'Máquinas e Dispositivos',
      items: ['Dispositivos de Controle', 'Dispositivos de Soldagem', 'Dispositivos de Montagem', 'Dispositivos de Usinagem']
    },
    {
      icon: <FaCubes />,
      title: 'Detalhamento e Entrega',
      items: ['Detalhamento Técnico', 'Desenhos de Fabricação', 'Lista de Materiais (BOM)', 'Documentação Completa']
    }
  ];

  const testimonials = [
    {
      text: "Profissionais da mais alta qualidade! Atendimento ímpar.",
      author: "Rodrigo",
      photo: dep4Photo,
      stars: 5,
      timeAgo: "Há 3 dias"
    },
    {
      text: "Empresa de ponta em automação e robótica. O trabalho de alta qualidade, e a equipe demonstra grande competência técnica. Recomendo a quem busca inovação e parceiros confiáveis no setor de tecnologia.",
      author: "Anderson Fernandes",
      photo: dep1Photo,
      stars: 5,
      timeAgo: "2 meses atrás"
    },
    {
      text: "Excelente empresa. Possui ótimo atendimento e confiabilidade.",
      author: "Danilo Carvalho Souza",
      photo: dep2Photo,
      stars: 5,
      timeAgo: "Há 10 semanas"
    },
    {
      text: "Recomendo fortemente esta empresa para quem busca inovação, qualidade em visão computacional e IA. Presenciei em primeira mão o compromisso com a excelência, ética e respeito mútuo. A Vega Robotics entrega soluções de ponta para a indústria, constrói parcerias sólidas com clientes e instituições acadêmicas de renome, garantindo produtos inovadores e resultados impressionantes. Tive experiências incrivelmente positivas nessa empresa, recomendo-a a clientes, colaboradores e parceiros.",
      author: "Sttela Bastos",
      photo: dep3Photo,
      stars: 5,
      timeAgo: "Há 14 semanas"
    }
  ];

  const whatsappLink = "https://wa.me/5511944271000?text=Olá! Tenho uma dúvida sobre os serviços de engenharia.";
  const calendarLink = "https://cal.com/vega-robotics-u33xqg/30min";
  const phone = "(11) 94427-1000";
  const email = "contato@vegarobotics.com.br";

  // Função para abrir o modal
  const openModal = (e) => {
    e.preventDefault();
    setIsModalOpen(true);
  };

  return (
    <PageWrapper>
      <GridBackground />
      
      {/* MODAL DE FORMULÁRIO HUBSPOT */}
      <ContactFormModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />
      
      {/* HERO */}
      <HeroSection>
        <HeroContent>
          <div>
            <HeroBadge className="animate-on-scroll">
              <FaIndustry /> Engenharia Aplicada sob demanda
            </HeroBadge>
            
            <HeroTitle className="animate-on-scroll">
              Terceirize seus projetos
              <span className="highlight">Simplifique sua operação</span>
            </HeroTitle>
            
            <HeroSubtitle className="animate-on-scroll">
              Equipe sobrecarregada? Terceirize seus projetos de ferramentaria com quem entrega — da análise crítica ao detalhamento final. A mais de 15 anos entregando qualidade em projetos.
            </HeroSubtitle>
            
            <HeroCTA className="animate-on-scroll">
              <HeroButton href="#" onClick={openModal}>
                <FaEnvelope /> Solicitar Orçamento
              </HeroButton>
              <HeroButtonSecondary href="#servicos">
                Ver Serviços <FaArrowRight />
              </HeroButtonSecondary>
            </HeroCTA>
          </div>
          
          {/* IMAGENS/GIFs - Tooltip aparece no hover */}
          <HeroImageStack className="animate-on-scroll">
            {heroImages.map((item, index) => (
              <HeroImageWrapper
                key={index}
                style={{
                  opacity: index === activeIndex ? 1 : 0,
                  pointerEvents: index === activeIndex ? 'auto' : 'none'
                }}
              >
                <HeroImageCard
                  src={item.src}
                  alt={item.alt}
                  data-position={index === activeIndex ? "0" : "1"}
                />
                <HeroImageTooltip>
                  <span>{item.label}</span>
                </HeroImageTooltip>
              </HeroImageWrapper>
            ))}
          </HeroImageStack>
        </HeroContent>
      </HeroSection>

      {/* SERVIÇOS */}
      <ServicesSection id="servicos">
        <SectionHeader className="animate-on-scroll">
          <SectionTitle>O que entregamos</SectionTitle>
          <SectionSubtitle>
            Engenharia de projetos sob demanda para sua operação
          </SectionSubtitle>
        </SectionHeader>

        <ServicesGrid>
          {services.map((service, index) => (
            <ServiceCard 
              key={index} 
              className="animate-on-scroll"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <ServiceIcon>{service.icon}</ServiceIcon>
              <ServiceTitle>{service.title}</ServiceTitle>
              <ServiceList>
                {service.items.map((item, i) => (
                  <li key={i}>
                    <FaCheck /> {item}
                  </li>
                ))}
              </ServiceList>
            </ServiceCard>
          ))}
        </ServicesGrid>
      </ServicesSection>

      {/* DEPOIMENTOS */}
      <TestimonialsSection id="depoimentos">
        <TestimonialsHeader className="animate-on-scroll">
          <TestimonialsTitle>
            O que <span>profissionais</span> dizem<br />
            sobre nosso trabalho
          </TestimonialsTitle>
        </TestimonialsHeader>

        <TestimonialsWrapper>
          <CarouselButton 
            className="prev" 
            onClick={() => setTestimonialIndex(prev => Math.max(0, prev - 1))}
            disabled={testimonialIndex === 0}
          >
            <FaChevronLeft />
          </CarouselButton>
          
          <TestimonialsTrack>
            <TestimonialsCarousel 
              $offset={-testimonialIndex * 33.33} 
              $mobileOffset={-testimonialIndex * 100}
            >
              {testimonials.map((testimonial, index) => (
                <TestimonialCardComponent 
                  key={index}
                  testimonial={testimonial}
                  index={index}
                  onPause={pauseCarousel}
                />
              ))}
            </TestimonialsCarousel>
          </TestimonialsTrack>
          
          <CarouselButton 
            className="next" 
            onClick={() => setTestimonialIndex(prev => Math.min(maxTestimonialIndex, prev + 1))}
            disabled={testimonialIndex >= maxTestimonialIndex}
          >
            <FaChevronRight />
          </CarouselButton>
        </TestimonialsWrapper>

        <CarouselControls>
          {[...Array(maxTestimonialIndex + 1)].map((_, index) => (
            <CarouselDot 
              key={index}
              $active={testimonialIndex === index}
              onClick={() => setTestimonialIndex(index)}
            />
          ))}
        </CarouselControls>
      </TestimonialsSection>

      {/* CTA FINAL */}
      <CTASection id="contato">
        <CTAContent className="animate-on-scroll">
          <CTATitle>
            Pronto para simplificar sua engenharia?
          </CTATitle>
          <CTASubtitle>
            Envie seus desenhos e requisitos. Respondemos em até 24h.
          </CTASubtitle>
          
          <CTAButtons>
            <PrimaryButton href="#" onClick={openModal}>
              <FaEnvelope /> Solicitar Orçamento
            </PrimaryButton>
            <SecondaryButton href={calendarLink} target="_blank" rel="noopener noreferrer">
              <FaCalendarAlt /> Agendar Reunião
            </SecondaryButton>
          </CTAButtons>

          <ContactRow>
            <span><FaPhone /> {phone}</span>
            <span><FaEnvelope /> {email}</span>
          </ContactRow>
        </CTAContent>
      </CTASection>

      {/* WHATSAPP FLUTUANTE */}
      <WhatsAppFloat href={whatsappLink} target="_blank" rel="noopener noreferrer" aria-label="Tirar dúvidas no WhatsApp">
        <FaWhatsapp />
      </WhatsAppFloat>

      {/* BANNER DE COOKIES (LGPD) */}
      <CookieConsent />
    </PageWrapper>
  );
};

export default EngenhariaAplicada;